
import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface DescriptionSectionProps {
  shortDescription: string;
  onDescriptionChange: (description: string) => void;
}

const DescriptionSection: React.FC<DescriptionSectionProps> = ({
  shortDescription,
  onDescriptionChange
}) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-start lg:gap-4">
      <Label htmlFor="description" className="lg:w-32 lg:flex-shrink-0 text-sm font-medium lg:pt-2">
        Short Description *
      </Label>
      <Textarea
        id="description"
        placeholder="Briefly describe what this tutorial covers..."
        value={shortDescription}
        onChange={(e) => onDescriptionChange(e.target.value)}
        rows={3}
        className="lg:flex-1"
      />
    </div>
  );
};

export default DescriptionSection;
